import { render, staticRenderFns } from "./LayoutLk.vue?vue&type=template&id=66ff38cf"
import script from "./LayoutLk.vue?vue&type=script&lang=js"
export * from "./LayoutLk.vue?vue&type=script&lang=js"
import style0 from "./LayoutLk.vue?vue&type=style&index=0&id=66ff38cf&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports